import { Flex, Icon, IconButton } from "@chakra-ui/react"
import { useEffect, useState } from "react";
import { TbChevronLeft, TbChevronRight } from 'react-icons/tb'

import DateBox from "./DateBox";
import { isSameDay } from "../../pages/user/NotificationEvents";

interface DatePickerProps {

    daysPerPage: number;
    date: Date|null;
    setDate: React.Dispatch<React.SetStateAction<Date|null>>;
    datesWithEventsSet?: any;
}
const generateDateArray = (numDates: number, offset: number): Date[] => {
    const today = new Date();
    today.setDate(today.getDate() + offset);
  
    return Array.from({ length: numDates }, (_, i) => new Date(today.getTime() + i * 24 * 60 * 60 * 1000));
};

const calculateOffsetForDate = (date: Date, daysPerPage: number): number => {
    const today = new Date();
    const diffInTime = date.getTime() - today.getTime();
    const diffInDays = Math.ceil(diffInTime / (1000 * 3600 * 24));
    return Math.floor(diffInDays / daysPerPage);
};

function formatDateForComparison(date: Date): string {
    // Format the date as 'YYYY-MM-DD' using local timezone components.
    // IMPORTANT: Do NOT use toISOString() here — it converts to UTC, which shifts
    // the date forward by 1 day for users west of UTC (e.g. LA at 5pm PST = next day in UTC).
    // The backend returns event dates in the venue's local timezone, so we must compare
    // using local date components to match correctly.
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

const DatePicker = (props:DatePickerProps) => {
    const [offset,setOffset] = useState(0)
    useEffect(() => {
        
        if (!props.date) return;
        if (isSameDay(props.date, new Date())) return;
        const newOffset = calculateOffsetForDate(props.date, props.daysPerPage);
        setOffset(newOffset);   
    }, [props.date])

    return <Flex 
        justifyContent='space-between'
        alignItems='center'
        gap="4px"
    >
        <IconButton 
            aria-label='back'
            variant='light'
            size='xs'
            isDisabled={offset === 0}
            onClick={() => setOffset(offset-1)}
            icon={<Icon w='16px' h='16px' as={TbChevronLeft} />}
        />
        {generateDateArray(props.daysPerPage,props.daysPerPage * offset).map((date:Date,i:number) => {
            return <DateBox 
                date={date} onClick={() => {
                    isSameDay(date,props.date) ? props.setDate(null) : props.setDate(date)

                }} 
                    key={i} 
                activeDate={props.date}
                hasEvent={props.datesWithEventsSet?.has(formatDateForComparison(date))}
            />
        })}
        <IconButton 
            aria-label='back'
            variant='light'
            size='xs'
            onClick={() => setOffset(offset+1)}
            icon={<Icon w='16px' h='16px' as={TbChevronRight} />}
        />
        
    </Flex>
}


export default DatePicker